<div #el>
    <ax-select-box>
    </ax-select-box>
</div>